import React, { Component } from 'react';
import { connect } from 'react-redux';
import CheckDeliveryDispatchResultModal from '../../../../views/order/common/modal/CheckDeliveryDispatchResultModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class CheckDeliveryDispatchResultModalContainer extends Component {
  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'checkDeliveryDispatchResultModal',
    });
  };

  /**
   * 발송 처리하기
   */
  onSubmit = () => {
    const { data, deliveryDispatch } = this.props;
    const { deliveryInfoOrderItemList } = data;

    /**
     *  발송 처리
     */
    deliveryDispatch({
      deliveryInfoOrderItemList,
    });

    this.closeModal();
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <CheckDeliveryDispatchResultModal
        isOpen={isOpen}
        data={data}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.checkDeliveryDispatchResultModal.isOpen,
    data: state.order.checkDeliveryDispatchResultModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  deliveryDispatch: orderActions.deliveryDispatch,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(CheckDeliveryDispatchResultModalContainer));
